import BaseService from './_base.service';

export const rentalfamilyService = {
    page,
    search,
    combo,
    edit,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/rental/family/page/"+page+"/"+size, callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/rental/family/page/"+page+"/"+size,filter, callback, true)
}

function combo( callback) {
    return BaseService.get("/rental/family/combo/", callback, true)
}
function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/rental/family/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/rental/family/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/rental/family/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/rental/family/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/rental/family/"+id+"/logic", callback);
}
